import React, { useState } from 'react'

import { Icon } from '@clientbase/clientbase-library'
import { Tooltip } from '@mui/material'
import { parseCookies } from 'nookies'

import ModalSurveyNPS from 'components/Modal/ModalSurveys/ModalSurveyNPS'
import * as SurveyStyles from 'components/Survey/Survey.styles'

import { theme } from 'styles/theme'

const TOOLTIP_MESSAGE =
  'Participe da nossa pesquisa de satisfação e ajude a priorizar as demandas'

/**
 * Entrada manual da pesquisa de NPS na topbar.
 * O convite fica no banner de avisos da conta (SC-11817), que abre o modal
 * pelo NPSSurveyTrigger; a pesquisa nunca abre sozinha.
 */
const NPSButton = () => {
  const { ['nextauth.show_nps']: showNps } = parseCookies()

  const [isModalOpen, setIsModalOpen] = useState(false)

  if (showNps !== 'true') return null

  return (
    <>
      <Tooltip title={TOOLTIP_MESSAGE} arrow>
        <SurveyStyles.TriggerButton onClick={() => setIsModalOpen(true)}>
          <Icon icon="assignment" colorSX={theme.palette.primary.main} />
          <SurveyStyles.BadgeDot />
        </SurveyStyles.TriggerButton>
      </Tooltip>

      {isModalOpen && (
        <ModalSurveyNPS
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  )
}

export default NPSButton
